import { gql  } from '@apollo/client'

export const LOGIN_USER = gql`
    mutation(
        $username: String!
        $password: String!
    ) {
      login(
        username: $username,
        password: $password
      )
    }
  `;

export const REGISTER_USER = gql`
      mutation(
        $username: String!
        $password: String!
        $name: String!
        $email: String!
        $schoolType: SchoolType!
        $schoolName: String!
        $identityPhotoFile: Upload!
      ) {
        register(
            username: $username
            password: $password
            name: $name
            email: $email
            schoolType: $schoolType
            schoolName: $schoolName
            identityPhotoFile: $identityPhotoFile
        )
      }
    `;
export const CHANGE_PASS = gql`
      mutation(
        $token: String!
        $password: String!
      ) {
        resetPassword(
          token: $token
          password: $password
        )
      }
    `;

export const CONFIRM_ACCOUNT = gql`
      mutation(
        $token: String!
      ) {
        confirmAccount(
          token: $token
        )
      }
    `;

export const REQUEST_GET_PASSWORD = gql`
      mutation(
        $email: String!
      ){
        requestForgetPassword(
          email: $email
        )
      }
    `;

export const USER_PROFILE = gql`
      query {
        profile {
          username,
          name,
          email,
          schoolName,
          schoolType,
          identityPhotoUrl,
          workshops {name},
          teams {
              name,
              abstractFilename,
              abstractFileUrl,
              paperFilename,
              paperFileUrl,
              id,
              competition {name},
              payment {status, url}
          },
          leads {
              name,
              abstractFilename,
              abstractFileUrl,
              paperFilename,
              paperFileUrl,
              id,
              competition {name},
              payment {status, url}
          },
          WorkshopFirstToAccount {
            id,
            workshopVerifyFilename,
            isWorkshopVerified,
            WorkshopVerifyFileUrl,
            paymentStatus,
          }
        }
      }
    `;

export const REGISTER_TEAM = gql`
      mutation(
        $competitionId: Int!
        $teamName: String!
        $members: [Int!]!
        $lineId: String!
        $phone: String!
        $promo: Upload
      ) {
        registerTeam(
            competitionId: $competitionId
            teamName: $teamName
            members: $members
            lineId: $lineId
            phone: $phone
            promo: $promo
        )
      }
    `;


export const FIND_USER = gql`
      query(
        $username: String!
      ) {
        findUserByUsername(
            username: $username
        ) {
            username,
            id
        }
      }
    `;

export const SUBMIT_ABSTRACT = gql`
      mutation(
        $teamId: Int!,
        $abstractFile: Upload!
      ) {
        submitAbstract(
            teamId: $teamId,
            abstractFile: $abstractFile
        )
      }
    `;

export const SUBMIT_PAPER = gql`
      mutation(
        $teamId: Int!,
        $paperFile: Upload!
      ) {
        submitPaper(
            teamId: $teamId,
            paperFile: $paperFile
        )
      }
    `;
export const REGISTER_WORKSHOP = gql`
      mutation(
        $isCheckbox: Boolean!
      ){
        registerWorkshop(
          isCheckbox: $isCheckbox
        )
      }
    `;


export const SUBMIT_WORKSHOP = gql`
      mutation(
        $workshopId: Int!,
        $workshopVerifyFile: Upload!
      ) {
        submitWorkshop(
          workshopId: $workshopId,
          workshopVerifyFile: $workshopVerifyFile
        )
      }
    `;

export const FIND_TEAM_UNI = gql`
      query {
        findTeamUniv {
            name,
            abstractFileUrl,
            paperFileUrl,
        }
      }
    `;

export const FIND_TEAM_SMA = gql`
    query {
      findTeamSMA {
          name,
          abstractFileUrl,
          paperFileUrl,
      }
    }
  `;
